module.exports = __webpack_public_path__ + "img/testexperience-min.cb819570.jpg";